import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '../Icon';
import heroDots from './hero-dots.svg';
import redCircle from './red-circle.svg';
import { theme } from '../../styles/GlobalStyles';

const Wrapper = styled.div`
  position: relative;
  z-index: 1;
  height: 500px;
  width: 100%;
  background: #1F2432;
  margin-top: -65px;

  .dot-bg {
    position: absolute;
    z-index: 2;
    top: 130px;
    left: 0px;
  }

  .red-circle {
    position: absolute;
    z-index: 2;
    top: 104px;
    right: 0;
  }

  .category-blue-circle {
    position: absolute;
    bottom: 30px;
    left: -30px;
  }

  .content-wrap {
    position: absolute;
    z-index: 3;
    top: calc(50% + 25px);
    left: 50%;
    transform: translate(-50%, -50%);
    width: 661px;
    text-align: center;

    h1 {
      color: ${theme.heading.dark};
    }

    p {
      color: ${theme.heading.dark};
    }

    form {
      position: relative;
      margin-bottom: 0;
      z-index: 5;

      .search-icon {
        position: absolute;
        z-index: 3;
        top: 16px;
        left: 16px;
      }
      .blue-circle {
        position: absolute;
        z-index: 1;
        top: -20px;
        left: -20px;
      }
    }

    input {
      position: relative;
      z-index: 2;
      width: 100%;
      margin-bottom: 0;
      font-size: 16px;
      line-height: 19.2px;
      padding: 16px 16px 17px 52px;
      outline: none;
      border-radius: 6px;
      border: 0;
    }
    .gatsby-image-wrapper {
      width: 30px;
      height: 30px;
      margin-left: 3px;
      display: inline-block;
      vertical-align: bottom;
      margin-bottom: -5px;
    }
  }

  @media (max-width: 767px) {
    height: 315px;
    .dot-bg {
      top: 50px;
      left: -205px;
    }
    .red-circle {
      top: 0px;
      right: -50px;
    }
    .content-wrap {
      top: calc(50% + 20px);
      width: 317px;
    }
    .blue-circle {
      display: none;
    }
  }
  @media (min-width: 768px) and (max-width: 989px) {
    .dot-bg {
      top: 103px;
      left: -120px;
    }
    .red-circle {
      right: -50px;
    }
    p {
      width: 310px;
      margin: 12px auto 28px;
    }
  }
`;

const HelpHero = ({ children, categoryPage }) => (
  <Wrapper>
    <div className="dot-bg">
      <img src={heroDots} alt="search hero dots" />
    </div>
    <div className="red-circle">
      <img src={redCircle} alt="red-circle" />
    </div>
    <div className="content-wrap">
      {children}
    </div>
    {categoryPage ? (
      <div className="category-blue-circle">
        <Icon name="blueCircle" color={theme.icon.blueIcon} />
      </div>
    ) : (
      <></>
    )}
  </Wrapper>
);

HelpHero.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any.isRequired,
  categoryPage: PropTypes.bool.isRequired,
};

export default HelpHero;
